const state = {
  isDarkMode: localStorage.getItem('darkMode') === 'true' || false
};

const getters = {
  isDarkMode: state => state.isDarkMode
};

const mutations = {
  toggleDarkMode(state) {
    state.isDarkMode = !state.isDarkMode;
    localStorage.setItem('darkMode', state.isDarkMode);
  },

  setDarkMode(state, value) {
    state.isDarkMode = value;
    localStorage.setItem('darkMode', value);
  }
};

const actions = {
  initializeDarkMode({ commit }) {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      commit('setDarkMode', savedMode === 'true');
    } else {
      commit('setDarkMode', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
